import { ResidualsOutlook, DailyResidualsResponse, ResidualsOutlookResponse } from './../../../../../shared/models/dashboardModels';
import { Component, OnInit, Input } from '@angular/core';
import { BindingContext } from 'app/shared/models/BindingContext';
import { DashboardService } from 'app/shared/services/dashboard.service';
import { Router } from '@angular/router';
import { UserAccessService } from 'app/shared/services/user-access.service';
import { HttpErrorResponse } from '@angular/common/http';
import { reduce } from 'rxjs/operators';

@Component({
	selector: 'app-residual-outlook-chart',
	templateUrl: './residual-outlook-chart.component.html',
	styleUrls: ['./residual-outlook-chart.component.scss']
})
export class ResidualOutlookChartComponent implements OnInit {
	@Input() bindingContext: BindingContext;
	private dashboardError = 'Error loading dashboard item, please contact support.';
	private debug = false;
	datasets = new Array<any>();
	monthCardTypes = new Array<string>();
	yearCardTypes = new Array<string>();
	public internalMessage: string;
	public errorMessage: string;
	_currentTabName: string;
	public permitClick = false;
	public pieChartOptions = { responsive: true };
	labels: string[] = new Array<string>();
	public rawData: ResidualsOutlookResponse[];


	chartType = 'bar';
	options: any = {
		responsive: true,
		legend: { position: 'none' },
		scales: {
			yAxes: [{
				ticks: {
					beginAtZero: true
				}
			}]
		},
		tooltips: {
			backgroundColor: 'rgba(0, 0, 0, 0.5)',
			titleAlign: 'center',
			bodyAlign: 'center',
		},
	};
	chartColors: any[] = [
		{
			backgroundColor: this.getColors(),
		}
	];
	residualOutlookInfoBarData: any;
	//#endregion

	//#region Construction
	constructor(private dashboardSvc: DashboardService,
		private router: Router,
		private accessSvc: UserAccessService) {
		this.SetClickThrough();
	}

	ngOnInit() {
		this.getData();
	}
	//#endregion

	getColors(): Array<string> {
		const result = new Array<string>();
		for (let i = 0; i < 2; i++) {
			result.push(
				'rgb(37,80,160,0.7)',
				'rgb(108,140,199,0.7)',
				'rgb(170,225,255,0.7)',
				'rgb(1,64,190,0.7)',
				'#AAE1FF',
				'#58595B',
				'#C3C6C9',
				'#5f2E8C',
				'#6C8CC7',
				'#f58231', // orange
				'#3cb44b', // green
				'#000080', // navy
				'#aa6e28', // brown
				'#800000', // maroon
				'#911eb4', // purple
				'#aaffc3', // mint
				'#0082c8', // blue
				'#46f0f0', // cyan
				'#f032e6', // magenta
				'#008080', // teal
				'#fabebe', // pink
				'#e6beff', // lavender
				'#d2f53c', // lime
				'#fffac8', // beige
				'#808000', // olive
				'#ffd8b1', // coral
				'#ffe119', // yellow
				'#808080' // grey
			);

		}
		return result;
	}
	SetClickThrough() {
		this.accessSvc.GetAccessLevelBySecurableName('|OPEN-NOT-PROCESSING', 'REPORTS', null, null, false).then(resp => {
			if (resp > 0) {
				// They have at least read access
				this.permitClick = true;
			}
		});
	}

	onChartClick(event: any) {
		if (this.permitClick) {
			this.router.navigate(['/residuals']);
		}
	}

	// turn the data from the API into data chart.js can read
	populateDataSet(rawData) {
		this.residualOutlookInfoBarData = rawData;

		const tempResidualsData = new Array<number>();
		this.labels = new Array<string>();
		this.datasets = new Array<any>();


		for (const item of rawData.ResOutlook) {
			this.labels.push(item.CommissionsDate.substring(5, 10));
			tempResidualsData.push(item.TotalRes as number);
		}
		this.datasets = [{label: '',  data: tempResidualsData }] ;

	}

	getData() {
		this.bindingContext.beginGet();
		this.errorMessage = undefined;

		this.dashboardSvc.GetResidualOutlook().subscribe(
			(resp: ResidualsOutlookResponse[]) => {
				this.rawData = resp;
				this.bindingContext.endGet();
				this.populateDataSet(resp);

			},
			(response: HttpErrorResponse) => {
				this.bindingContext.endGet();
				this.bindingContext.showAlert(BindingContext.alertType.danger, this.dashboardError, true);
			}
		);

	}
}
